/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.4
 */

import { FormikValues } from 'formik';
import * as Yup from 'yup';

import IPageAuthTranslation from '../../../../modules/internationalization/types/pages/auth';
import { IChangePasswordState } from '../../types/changePasswordTypes';

export const passwordValidation = (translation: IPageAuthTranslation, validationParams: IChangePasswordState) => {
    const { alphabet, minLength, maxLength, requiredDigit, requiredLetter } = validationParams;
    const letterRegExp = /[a-z]/i;
    const digitRegExp = /[0-9]/;
    const legalLettersRegExp = new RegExp('^[' + alphabet + ']*$');
    const options = {
        context: { alphabet, requiredDigit, requiredLetter },
        abortEarly: true,
    };
    const messageIllegalLength = minLength && maxLength &&
        translation.changePasswordForm.illegalLength
        .replace('{min}', minLength.toString())
        .replace('{max}', maxLength.toString()) || '';

    return (values: FormikValues) => {
        let result = {};
        try {
            Yup.object().shape({
                password: Yup.string()
                    .min(minLength, messageIllegalLength)
                    .max(maxLength, messageIllegalLength)
                    .when('$requiredLetter', {
                        is: true,
                        then: Yup.string()
                            .matches(letterRegExp, translation.changePasswordForm.requiredLetter),
                    })
                    .when('$requiredDigit', {
                        is: true,
                        then: Yup.string()
                            .matches(digitRegExp, translation.changePasswordForm.requiredDigit),
                    })
                    .when('$alphabet', {
                        is: (value: string) => value !== '',
                        then: Yup.string()
                            .matches(legalLettersRegExp, translation.changePasswordForm.illegalLetters),
                    }),
                passwordConfirm: Yup.string()
                    .oneOf([Yup.ref('password')], translation.changePasswordForm.notEqualsPasswords),
            }).validateSync(values, options);
        } catch (errors: any) {
            result = { [errors.path]: errors.message };
        }
        return result;
    }
};
